import { Component, Input } from '@angular/core';
import { BaseInquiryStatus, BaseInquiryStatusType } from '../../../modules/inquiry/_enums/base-inquiry.enum';

@Component({
  selector: 'base-offers-status',
  templateUrl: './base-offers-status.component.html',
})
export class BaseOffersStatusComponent {
  @Input() state: BaseInquiryStatusType | undefined;
  @Input() confirmedOffers: number | undefined;
  @Input() openOffers: number | undefined;
  @Input() declinedOffers: number | undefined;
  @Input() needConfirmationOffers: number | undefined;
  @Input() showHyphenIfEmpty = true;
  @Input() areDeclinedOffersAvailable = true;
  baseInquiryStatus = BaseInquiryStatus;
}
